<template>
  <TrainerLayout>
    <div class="container mx-auto px-0 sm:px-0 lg:px-0">
      <div class="px-0 sm:px-0 lg:px-0">
        <div class="sm:flex sm:items-center">
          <div class="sm:flex-auto">
            <h1 class="text-base font-semibold leading-6 text-gray-900">
              Batches
            </h1>
            <p class="mt-2 text-sm text-gray-700">
              A list of all the batches in your account including their name,
              title, email and role.
            </p>
          </div>
          <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <button
              type="button"
              class="block rounded-md bg-indigo-600 py-2 px-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Add batch
            </button>
          </div>
        </div>
        <div class="mt-8 flow-root">
          <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
            >
              <div class="relative">
                <!-- Selected row actions, only show when rows are selected. -->
                <!-- <div class="absolute top-0 left-14 flex h-12 items-center space-x-3 bg-white sm:left-12"> -->
                <!--   <button type="button" class="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">Bulk edit</button> -->
                <!--   <button type="button" class="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">Delete all</button> -->
                <!-- </div> -->
                <table class="min-w-full table-fixed divide-y divide-gray-300">
                  <thead>
                    <tr v-if="fields && fields.length">
                      <th scope="col" class="relative px-7 sm:w-12 sm:px-6">
                        <input
                          type="checkbox"
                          class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                      </th>
                      <!-- <th
                        scope="col"
                        class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900"
                      >
                        Name
                      </th> -->
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        v-for="d in fields"
                        :key="d"
                      >
                        {{ d }}
                      </th>
                      <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-3">
                        <span class="sr-only">Edit</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    class="divide-y divide-gray-200 bg-white"
                    v-if="items && items.length"
                  >
                    <!-- Selected: "bg-gray-50" -->
                    <tr v-for="d in items" :key="d.id">
                      <td class="relative px-7 sm:w-12 sm:px-6">
                        <!-- Selected row marker, only show when row is selected. -->
                        <!-- <div class="absolute inset-y-0 left-0 w-0.5 bg-indigo-600"></div> -->

                        <input
                          type="checkbox"
                          class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                      </td>
                      <!-- Selected: "text-indigo-600", Not Selected: "text-gray-900" -->
                      <td
                        class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900"
                      >
                        {{ d.name }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        {{ d.title }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        <div class="flex items-center">
                          <Dollar class="w-6 h-6" />
                          <span>
                            {{ d.cost == 0 ? "Free" : intToFloat(d.cost, 2) }}
                          </span>
                        </div>
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        <span
                          class="inline-flex rounded-full bg-green-10 px-2 text-xs font-semibold leading-5 text-green-80"
                          :class="
                            d.status == 1
                              ? 'bg-green-100 text-green-800'
                              : 'bg-red-100 text-red-800'
                          "
                        >
                          {{ d.status == 1 ? "Active" : "In-Active" }}
                        </span>
                      </td>
                      <td
                        class="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3"
                      >
                        <a
                          href="#"
                          class="text-indigo-600 hover:text-indigo-900"
                          >Edit<span class="sr-only">, Lindsay Walton</span></a
                        >
                      </td>
                    </tr>

                    <!-- More people... -->
                  </tbody>
                </table>
                <PaginationComponent
                  v-if="items.length"
                  :currentPage="current_page"
                  :handlePageChange="handlePageChange"
                  :totalPages="last_page"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import { Dollar } from "@/components/icons";
import { PaginationComponent } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Batches",
  components: {
    Dollar,
    TrainerLayout,
    PaginationComponent,
  },
  data() {
    return {
      fields: ["Name", "Title", "Cost", "Status"],
      items: [],
      current_page: 1,
      last_page: 1,
    };
  },
  computed: {
    ...mapGetters(["adminBatches"]),
  },
  methods: {
    ...mapActions(["getAdminBatches"]),

    handlePageChange() {},
  },
  async created() {
    await this.getAdminBatches();
    this.items = this.adminBatches.data;
  },
};
</script>